// extracted by mini-css-extract-plugin
export default {"loading":"PokemonList_loading__2Klgi","list":"PokemonList_list__-I7QQ","pokeCard":"PokemonList_pokeCard__WB05c"};